import { Component, OnInit, Output, OnDestroy, EventEmitter } from '@angular/core';
import { StorageService, ObservatoryService } from '@services/services.module';
import { CalendarService } from '../calendar.service';
import { ModalWeekService } from './modal-week.service';
import { Subscription } from 'rxjs';
import { DayData, WeekDays, ProjectData } from '../calendar-day/calendar-day.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-week',
  templateUrl: './modal-week.component.html',
  styleUrls: ['./modal-week.component.scss']
})

export class ModalWeekComponent implements OnInit, OnDestroy {
  @Output() actualizar: EventEmitter<any> = new EventEmitter();
  private subscriptions: Array<Subscription> = [];
  inputWeekData: Array<DayData>;
  arrayFilas: any;
  filasWeekData: Array<ProjectData> = [];
  public amountHoursS1: number;
  public amountHoursS2: number;
  public amountHoursS3: number;
  public imputacionData;
  public semana;
  public todosProyectos = this.storage.get('allProjects');
  workingWeek: any;
  fechaIni: string;
  endDate: string;


constructor(
    private storage: StorageService,
    private _observatoryService: ObservatoryService,
    private weekService: ModalWeekService,
    private modalService: NgbModal,
    public _calendarService: CalendarService
  ) {

  }

  ngOnInit() {

  }


  cancelarImputacion(): void {
    this.modalService.dismissAll();
  }



  /**
   * @name ngOnDestroy
   * @description Lifecycle hook
   */
  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }

}
